"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaCounter = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var TextareaCounter = function (props) {
    var id = props.id, count = props.count, maxCount = props.maxCount;
    var countId = id + "-count";
    var charRemaining = maxCount - count;
    return (React.createElement("span", { id: countId, className: "form-text--counter" },
        "Characters remaining: ",
        charRemaining));
};
exports.TextareaCounter = TextareaCounter;
exports.TextareaCounter.propTypes = {
    count: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    maxCount: PropTypes.number,
};
